<script>
import axios from 'axios'

let global_cart_instance = {
    cart: {
        summary: 0.00,
        items: []
    }
}

export default {
  name: 'CartMixin',
  data () {
    return global_cart_instance
  },
  methods: {
    addToCart: function() {

      var add_item = {
        unit_title: this.unitTitle,
        unit_price: this.unitPrice,
        unit_quantity: this.unitQuantity,
        content_type: this.contentType,
        object_id: this.objectId
      }

      axios.put("/cart/api/cart-item/add/", add_item)
      .then(response => {
        global_cart_instance.cart = response.data;
        this.step = 'cart-btn';
        this.btnValueText = 'Добавлено'
      })
      .catch(error => {
        this.errors = error.response.data;
        this.step = 'add-btn';
      });

    },
    addToCartDropdown: function () {
      this.errors = {}
      axios.put("/cart/api/cart-item/add/", this.cartItem)
      .then(response => {
        global_cart_instance.cart = response.data;
        this.step = 'cart-btn';
      })
      .catch(error => {
        this.step = 'add-btn';
        this.errors = error.response.data;
      });
    },
    saveCartItem: function(item,){

      if(item.quantity < 1) {
        item.quantity = 1;
      }

      axios.put("/cart/api/cart-item/"+item.id+'/', item)
      .then(response => {
        global_cart_instance.cart = response.data;
      })
      .catch(error => {
        this.errors = error.response.data;
      });
    },
    addCountToCartCart: function(item, counts=1){
      item.quantity = item.quantity + counts;

      axios.put("/cart/api/cart-item/"+item.id+'/', item)
      .then(response => {
        global_cart_instance.cart = response.data;
      })
      .catch(error => {
        this.errors = error.response.data;
      });
    },
    removeFromCart: function(item){
      axios.delete("/cart/api/cart-item/"+item.id+'/', item)
      .then(response => {
        global_cart_instance.cart = response.data;
        this.step = 'cart-btn';
      })
      .catch(error => {
        this.errors = error.response.data;
      });
    },
    deleteCountFromCart: function(item, counts=1){
      item.quantity = item.quantity - counts;

      if(item.quantity < 1){
        item.quantity = 1;
      }

      axios.put("/cart/api/cart-item/"+item.id+'/', item)
      .then(response => {
        global_cart_instance.cart = response.data;
      })
      .catch(error => {
        this.errors = error.response.data;
      });
    }
  }
}
</script>